<template>
  <div class>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Show Course Details</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="6" align="left">
          Course Name : {{course.name}}
        </v-col>
      </v-row>
      <v-row>
        <v-col align="left">
          Course Description :
          <div class="course-description" @click="handleLinkClick" v-html="course.description"></div>
        </v-col>
      </v-row>
      <v-row v-if="hasTopics">
        <v-col md="6" align="left">
          Tag : <v-chip v-for="item in course.topics.data" :key="item.id" class="mr-1 mb-1">{{ item.tag }}</v-chip>
        </v-col>
      </v-row>
          <v-row v-if="hasVideos">
            <v-col md="8" align="left">
            <VideoPlayer />
                <h2 class="mt-2">{{ selectedVideo.title }}</h2>
                <p class="mt-2">{{ selectedVideo.description }}</p>
              </v-col>
          </v-row>
              <v-card v-if="multiVideo" class="mb-5">
                <v-toolbar flat color="secondary" dark mb0 pb0>
                  <v-toolbar-title>Training Material</v-toolbar-title>
                </v-toolbar>
                <TrainingMaterial />
              </v-card>
              <v-card v-if="course.documents.data.length > 0" class="mb-5">
                <v-toolbar flat color="secondary" dark mb0 pb0>
                  <v-toolbar-title>Additional Content</v-toolbar-title>
                </v-toolbar>
                <SupplementalDocumentation />
              </v-card>

            </v-container>
          </div>
        </template>
        <script>
        import { IMPROVE_CONFIG } from "@/config.js";
        import TrainingMaterial from "@/pages/authenticated/courses/TrainingMaterial";
        import SupplementalDocumentation from "@/pages/authenticated/courses/SupplementalDocumentation";
        import VideoPlayer from "@/pages/authenticated/courses/VideoPlayer";
        import courseAPI from "@/api/course.js";
        export default {
          name: "ShowCourseDetail",
          components: {
            TrainingMaterial,
            SupplementalDocumentation,
            VideoPlayer
          },
          props: {
            id: {
              type: String,
              default: null
            },
            params: {
              type: String,
              default: ""
            },
            item: {
              type: Object,
              default: null
            }
          },
          data() {
            return {
              type: "thumbnail",
              accepted: "image/jpg,image/jpeg,image/png",
              search: "",
              messages: {},
              channels: [],
              valid: true,
              loading: false,
              successMessage: "Course Successfully Updated.",
              errorMessage:
                "Oops, something went wrong! Please check information is correct.",
              waitMessage: "Please wait, we are uploading your image."
            };
          },
          computed: {
            selectedTopics() {
              return this.course.topics.data.map(x => {
                return x.tag;
              });
            },
            totalVideos: function() {
              return this.course.total_videos;
            },
            multiVideo: function() {
              return this.course.videos.data.length > 1 ? true : false;
            },
            selectedVideo: function() {
              return this.$store.getters.currentVideo;
            },
            course: function() {
              return this.$store.getters.coursePlayer;
            },
            mimeType() {
              return this.selectedVideo.file.hasOwnProperty("data")
                      ? this.selectedVideo.file.data.mime_type
                      : this.selectedVideo.file.mime_type;
            },
            hasTopics: function() {
              if (
                      this.course.topics != null &&
                      this.course.topics.hasOwnProperty("data") &&
                      this.course.topics.data.length > 0
              ) {
                return true;
              } else {
                return false;
              }
            },
            hasVideos: function() {
              if (
                      this.course.videos != null &&
                      this.course.videos.hasOwnProperty("data") &&
                      this.course.videos.data.length > 0
              ) {
                return true;
              } else {
                return false;
              }
            },
            icon() {
              switch (this.mimeType) {
                case "video/mp4":
                  return "fa-video";
                  break;
                case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                  return "fa-file-word";
                  break;
                case "image/jpeg":
                case "image/png":
                  return "fa-image";
                  break;
                case "application/pdf":
                  return "fa-file-pdf";
                  break;
                default:
                  return "fa-file";
                  break;
              }
            }
          },
          mounted() {
            this.getCourse(this.id);
            this.$store.dispatch("setPlayVideo", false);
          },
          methods: {
            closePanel() {
              this.$emit("closePanel", {});
            },
            getCourse(id) {
              courseAPI
                .getCourse(id, "?include=thumbnail,enrolled,topics,videos,documents,test")
                .then(response => {
                  this.$store.dispatch("setCoursePreviewCoursePlayer", response.data.data);
                });
            },
            handleLinkClick(event) {
              // Check if the clicked element is a link
              if (event.target.tagName === 'A' || event.target.parentElement.tagName === 'A') {
                // Prevent the default action of the click event
                event.preventDefault();
                // Get the link URL
                const linkUrl = event.target.tagName === 'A' ? event.target.href : event.target.parentElement.href;
                // Open the link URL in a new tab
                window.open(linkUrl, '_blank');
              }
            }
          }
        };
        </script>